import { render } from "./ButtonPage.vue?vue&type=template&id=53faf0b2&scoped=true"
const script = {}

import "./ButtonPage.vue?vue&type=style&index=0&id=53faf0b2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53faf0b2"]])

export default __exports__